<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 24 20" fill="none">
    <path d="M22.6333 11.0671C23.3 10.5337 23.3 9.46706 22.6333 8.93373L14.2333 0.933729C13.5667 0.267061 12.5 0.933727 12.5 2.00039L12.5 7.33373C12.5 7.33373 6.36667 7.06706 3.16667 7.33373C1.7 7.46706 0.5 8.53373 0.5 10.0004C0.5 11.4671 1.7 12.5337 3.16667 12.6671C6.23333 12.9337 12.5 12.6671 12.5 12.6671L12.5 18.0004C12.5 19.0671 13.5667 19.7337 14.3667 19.0671L22.6333 11.0671Z" fill="#212121"/>
    </svg>
</template>
